






































































































































































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  UnitsApi,
  Unit,
  UnitFacility,
  DocumentRequest,
  FilesApi,
} from '@compassdigital/foodworks.ts.sdk';
import { cloneDeep } from 'lodash';
import VueImageLightboxCarousel from 'vue-image-lightbox-carousel';
import AppModule from '@/store/modules/app';
import FacilityEdit from '@/components/Form/Unit/FacilityEdit/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import UnitsUtil from '@/util/UnitUtil';
import UserModule from '@/store/modules/user';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {
    Textfield,
    PrimaryButton,
    TextButton,
    FacilityEdit,
    VueImageLightboxCarousel,
  },
})
export default class FacilityDetail extends Vue {
  @PropSync('unitFacility', {}) unitFacilityData!: UnitFacility;

  @PropSync('docImages', {}) docImagesSyn!: any;

  @PropSync('imageItems', {}) imageItem!: any;

  @Prop({}) unitId!: string;

  public edit: boolean = false;

  public saving: boolean = false;

  public cacheFilesImage = {};

  public cachedUnitFacility = {};

  public cachedUnitFacilityDetails = {};

  public showLightbox: boolean = false;

  public activeImage: any = 0;

  public activeImageNew: any = 0;

  public facilityPageInfo: any = {
    arrivalTime: '',
    reportingTime: '',
    serviceTime: {
      to: '',
      from: '',
    },
    avgPrepCount: '',
    uniformPermitted: '',
    uniformNotPermitted: '',
    parkingInformation: '',
    securityInformation: '',
    notes: '',
    unitPictures: [],
  };

  public facilityModal: any = {
    numericError: false,
    timeError: false,
    dialogSync: false,
    imageFiles: '',
  };

  public error: boolean = false;

  public onCancel() {
    this.unitFacilityData = this.cachedUnitFacility;
    this.facilityPageInfo = this.cachedUnitFacilityDetails;
    this.edit = false;
    this.error = false;
  }

  public onEdit() {
    this.cacheFilesImage = cloneDeep(this.docImagesSyn);
    this.cachedUnitFacility = cloneDeep(this.unitFacilityData);
    this.cachedUnitFacilityDetails = cloneDeep(this.facilityPageInfo);
    this.edit = true;
  }

  public async onSaveFacility() {
    if (
      this.unitFacilityData.arrivalTime
      && this.unitFacilityData.reportingTime
      && this.unitFacilityData.avgPrepCount
      && this.unitFacilityData.serviceTime?.to
      && this.unitFacilityData.serviceTime?.from
      && this.unitFacilityData.parkingInformation
      && this.unitFacilityData.uniformPermitted
      && this.unitFacilityData.uniformNotPermitted
      && this.facilityModal.numericError === false
      && this.facilityModal.timeError === false
    ) {
      const facility: UnitFacility = {
        arrivalTime: this.unitFacilityData.arrivalTime,
        reportingTime: this.unitFacilityData.reportingTime,
        serviceTime: this.unitFacilityData.serviceTime,
        serviceType: 'Lunch',
        avgPrepCount: this.unitFacilityData.avgPrepCount,
        uniformPermitted: this.unitFacilityData.uniformPermitted,
        uniformNotPermitted: this.unitFacilityData.uniformNotPermitted,
        parkingInformation: this.unitFacilityData.parkingInformation,
        securityInformation: this.unitFacilityData.securityInformation,
        notes: this.unitFacilityData.notes,
        unitPictures: this.unitFacilityData.unitPictures,
      };
      try {
        this.saving = true;
        const api = new UnitsApi(AppModule.apiConfig);
        const unitUser = await api.patchUnitById(this.unitId, { facility });
        if (unitUser.data) {
          const { data } = unitUser;
          this.unitFacilityData = data.facility as any;
          if (data.facility) {
            this.getFilesImage(data.facility as any);
            this.getFilesImage(data.facility as any);
            this.edit = false;
          }
          this.edit = false;
        }
      } catch (err) {
        const { error } = err.response.data;
        ToastModule.setToast({
          message: error.message,
          timeout: 5000,
        });
      }
      this.saving = false;
    } else {
      this.error = true;
    }
  }

  public async onSaveFacilityInfo() {
    if (
      this.facilityPageInfo.arrivalTime
      && this.facilityPageInfo.reportingTime
      && this.facilityPageInfo.avgPrepCount
      && this.facilityPageInfo.serviceTime
      && this.facilityPageInfo.parkingInformation
      && this.facilityPageInfo.uniformPermitted
      && this.facilityPageInfo.uniformNotPermitted
      && this.facilityModal.numericError === false
    ) {
      const facility: UnitFacility = {
        arrivalTime: this.facilityPageInfo.arrivalTime,
        reportingTime: this.facilityPageInfo.reportingTime,
        serviceTime: this.facilityPageInfo.serviceTime,
        serviceType: 'Lunch',
        avgPrepCount: this.facilityPageInfo.avgPrepCount,
        uniformPermitted: this.facilityPageInfo.uniformPermitted,
        uniformNotPermitted: this.facilityPageInfo.uniformNotPermitted,
        parkingInformation: this.facilityPageInfo.parkingInformation,
        securityInformation: this.facilityPageInfo.securityInformation,
        notes: this.facilityPageInfo.notes,
        unitPictures: this.facilityPageInfo.unitPictures,
      };
      try {
        const api = new UnitsApi(AppModule.apiConfig);
        const unitUser = await api.patchUnitById(this.unitId, { facility });
        if (unitUser.data) {
          const { data } = unitUser;
          this.unitFacilityData = data.facility as any;
          if (data.facility) {
            this.getFilesImage(data.facility as any);
            this.edit = false;
          }
          this.edit = false;
        }
      } catch (err) {
        const { error } = err.response.data;
        ToastModule.setToast({
          message: error.message,
          timeout: 5000,
        });
      }
    } else {
      this.error = true;
    }
  }

  public async getFilesImage(facility: UnitFacility) {
    const imageDoc = !facility.unitPictures
      || facility.unitPictures.map(async (id: string) => {
        try {
          const api = new FilesApi(AppModule.apiConfig);
          const fileResponse = await api.getFile(id);
          const { data } = fileResponse;
          if (data) {
            const { documents } = data as any;
            return documents;
          }
        } catch (err) {
          const { error } = err.response.data;
          ToastModule.setToast({
            message: error.message,
            timeout: 5000,
          });
        }
        return '';
      });

    Promise.all(imageDoc as any).then((images) => {
      this.docImagesSyn = images as any;
      this.imageItem = UnitsUtil.formatImages(this.docImagesSyn as any);
    });
  }

  public clickOnImage(image: DocumentRequest) {
    this.showLightbox = true;
  }

  public currentCheckImg: any = '';

  public nextImage() {
    let active = this.activeImageNew + 1;
    if (active >= this.docImagesSyn.length) {
      active = 0;
    }
    this.activateImage(active);
  }

  public prevImage() {
    let active = this.activeImageNew - 1;
    if (active < 0) {
      active = this.docImagesSyn.length - 1;
    }
    this.activateImage(active);
  }

  public activateImage(imageIndex: any) {
    this.activeImageNew = imageIndex;
  }

  get getCurrentImage() {
    if (this.docImagesSyn.length > 0) {
      this.currentCheckImg = this.docImagesSyn[this.activeImageNew].url;
      return true;
    }
    return '';
  }

  get accessAdminUser() {
    if (
      UserModule.currentRole === 'fw_admin'
      || UserModule.currentRole === 'fw_manager'
      || UserModule.currentRole === 'unit_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
